import VeerBalDiwas from '../Assets/Images/VeerBalDiwas.jpg'
import ChristmasCelebration from '../Assets/Images/ChristmasCelebration23_24.jpg'
import NurseryInteraction from '../Assets/Images/NurseryInteraction23_24.jpg'
import DiwaliCelebration from '../Assets/Images/DiwaliCelebration2023.jpg'
import TeacherDay from '../Assets/Images/TeacherDay.jpg'
import SchoolTrip2023 from '../Assets/Images/SchoolTrip2023.jpg'
import React from 'react'

const Gallery = () => {
  return (
    <>
<div className="gallery-blk">
                        <div className="gallery-img">
                            <img src={VeerBalDiwas} alt="Sacred Heart Convent School, Jagraon" />
                            <div className="title">
                                Veer Bal Diwas Celebrations
                            </div>
                        </div>
                        <div className="gallery-img">
                            <img src={ChristmasCelebration} alt="Sacred Heart Convent School, Jagraon" />
                            <div className="title">
                                Christmas Celebration 
                            </div>
                        </div>
                        <div className="gallery-img">
                            <img src={NurseryInteraction} alt="Sacred Heart Convent School, Jagraon" />
                            <div className="title">
                                Nursery Interaction 2024-25
                            </div>
                        </div>
                        <div className="gallery-img">
                            <img src={DiwaliCelebration} alt="Sacred Heart Convent School, Jagraon" />
                            <div className="title">
                                Diwali Celebration
                            </div>
                        </div>
                        <div className="gallery-img">
                            <img src={SchoolTrip2023} alt="Sacred Heart Convent School, Jagraon" />
                            <div className="title">
                               School Trip
                            </div>
                        </div>
                        <div className="gallery-img">
                            <img src={TeacherDay} alt="Sacred Heart Convent School, Jagraon" />
                            <div className="title">
                                Teacher's Day Celebrations
                            </div>
                        </div>
                    </div>
    </>
  )
}

export default Gallery
